import type { News } from '../../interface/News';
import type { Paginated } from '@/interface/Paginate';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';

export const getLastNews = async () => {
  const { data } = await api.get<Paginated<News>>(apiConfig.routes.news.last, {
    params: { page: 1, limit: 10 },
  });
  return data.data;
};

export const useGetLastNews = () =>
  useQuery({
    queryKey: ['news', 'last'],
    queryFn: getLastNews,
  });
